// components imports
import { AboutComponent } from './about/about';
import { DashboardRetailComponent } from './dashboard-retail/dashboard-retail';
import { LineChartComponent } from './line-chart/line-chart';
import { LoginWidgetComponent } from './login-widget/login-widget';
import { ModalComponentComponent } from './modal-component/modal-component';
import { NoDataComponent } from './no-data/no-data';
import { PeriodPickerComponent } from './period-picker/period-picker';
import { ProductPhotoComponent } from './product-photo/product-photo';
import { SidebarComponent } from './sidebar/sidebar';
import { SkuFeedCheckComponent } from './sku-feed-check/sku-feed-check';
import { SwAddressListComponent } from './sw-address-list/sw-address-list';
import { SwAllowedAppComponent } from './sw-allowed-app/sw-allowed-app';
import { SwAppLoaderComponent } from './sw-app-loader/sw-app-loader';
import { SwBottomDrawerComponent } from './sw-bottom-drawer/sw-bottom-drawer';
import { SwCardComponent } from './sw-card/sw-card';
import { SwCardExpandComponent } from './sw-card-expand/sw-card-expand';
import { SwColorCardComponent } from './sw-color-card/sw-color-card';
import { SwConfirmEmailComponent } from './sw-confirm-email/sw-confirm-email';
import { SwCopyClipboardComponent } from './sw-copy-clipboard/sw-copy-clipboard';
import { SwCountryPickerComponent } from './sw-country-picker/sw-country-picker';
import { SwCurrencyPickerComponent } from './sw-currency-picker/sw-currency-picker';
import { SwDatePickerComponent } from './sw-date-picker/sw-date-picker';
import { SwDateTimePickerComponent } from './sw-date-time-picker/sw-date-time-picker';
import { SwEditableFieldComponent } from './sw-editable-field/sw-editable-field';
import { SwEditableSaveComponent } from './sw-editable-save/sw-editable-save';
import { SwEmailListComponent } from './sw-email-list/sw-email-list';
import { SwFontAwesomeComponent } from './sw-font-awesome/sw-font-awesome';
import { SwGoogleMapsComponent } from './sw-google-maps/sw-google-maps';
import { SwHeaderComponent } from './sw-header/sw-header';
import { SwInfoComponent } from './sw-info/sw-info';
import { SwLanguagePickerComponent } from './sw-language-picker/sw-language-picker';
import { SwLoadingComponent } from './sw-loading/sw-loading';
import { SwMainMenuComponent } from './sw-main-menu/sw-main-menu';
import { SwMultiSelectComponent } from './sw-multi-select/sw-multi-select';
import { SwNotificationCenterComponent } from './sw-notification-center/sw-notification-center';
import { SwOrderByComponent } from './sw-order-by/sw-order-by';
import { SwPageComponent } from './sw-page/sw-page';
import { SwProgressCircleComponent } from './sw-progress-circle/sw-progress-circle';
import { SwReadMoreComponent } from './sw-read-more/sw-read-more';
import { SwScrollTopComponent } from './sw-scroll-top/sw-scroll-top';
import { SwSelectComponent } from './sw-select/sw-select';
import { SwSortComponent } from './sw-sort/sw-sort';
import { SwStartEndInputComponent } from './sw-start-end-input/sw-start-end-input';
import { SwStatusModalComponent } from './sw-status-modal/sw-status-modal';
import { SwSubheaderComponent } from './sw-subheader/sw-subheader';
import { SwSyncRequestsComponent } from './sw-sync-requests/sw-sync-requests';
import { SwTranslationPickerComponent } from './sw-translation-picker/sw-translation-picker';

export const components: any[] = [
  // components export
  AboutComponent,
  DashboardRetailComponent,
  LineChartComponent,
  LoginWidgetComponent,
  ModalComponentComponent,
  NoDataComponent,
  PeriodPickerComponent,
  ProductPhotoComponent,
  SidebarComponent,
  SkuFeedCheckComponent,
  SwAddressListComponent,
  SwAllowedAppComponent,
  SwAppLoaderComponent,
  SwBottomDrawerComponent,
  SwCardComponent,
  SwCardExpandComponent,
  SwColorCardComponent,
  SwConfirmEmailComponent,
  SwCopyClipboardComponent,
  SwCountryPickerComponent,
  SwCurrencyPickerComponent,
  SwDatePickerComponent,
  SwDateTimePickerComponent,
  SwEditableFieldComponent,
  SwEditableSaveComponent,
  SwEmailListComponent,
  SwFontAwesomeComponent,
  SwGoogleMapsComponent,
  SwHeaderComponent,
  SwInfoComponent,
  SwLanguagePickerComponent,
  SwLoadingComponent,
  SwMainMenuComponent,
  SwMultiSelectComponent,
  SwNotificationCenterComponent,
  SwOrderByComponent,
  SwPageComponent,
  SwProgressCircleComponent,
  SwReadMoreComponent,
  SwScrollTopComponent,
  SwSelectComponent,
  SwSortComponent,
  SwStartEndInputComponent,
  SwStatusModalComponent,
  SwSubheaderComponent,
  SwSyncRequestsComponent,
  SwTranslationPickerComponent,
];
